var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "c-form",
      attrs: {
        action: _vm.autocompleteUrl,
        method: "get",
        "accept-charset": "utf-8",
      },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.redirectToSearch.apply(null, arguments)
        },
      },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "c-form__item c-form__item--text" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.keyword,
              expression: "keyword",
            },
          ],
          ref: "searchInput",
          class: {
            "c-form__input js-search-input": true,
            "is-empty": !_vm.keyword,
            "is-open": _vm.isOpen,
          },
          attrs: {
            type: "text",
            id: "autocomplete-" + parseInt(Math.random() * 1000),
            name: "search",
            autocomplete: "off",
            placeholder: _vm.inputPlaceholder,
          },
          domProps: { value: _vm.keyword },
          on: {
            focus: _vm.showForm,
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.redirectToSearch.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.keyword = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      !_vm.isFormVisible
        ? _c(
            "a",
            {
              staticClass: "c-btn c-btn--secondary",
              class: {
                "is-open": _vm.isOpen,
              },
              attrs: { href: _vm.searchUrl },
            },
            [
              _c("i", {
                staticClass: "ico ico-search cxs-is-visible xs-is-visible",
              }),
              _vm._v(" "),
              _c("span", { staticClass: "cxs-is-hidden xs-is-hidden" }, [
                _vm._v(_vm._s(_vm.$t("Autocomplete.Header.buttonText"))),
              ]),
            ]
          )
        : _c(
            "button",
            {
              class: {
                "c-btn c-btn--square c-btn--close": true,
                "is-open": _vm.isOpen,
              },
              attrs: { type: "button" },
              on: { click: _vm.hideForm },
            },
            [
              _c("i", {
                staticClass: "ico ico-close-thick",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("i", { staticClass: "ico ico-shadow-search" }, [
      _c("i", { staticClass: "path1" }),
      _c("i", { staticClass: "path2" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }